import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { getUserStats } from 'api';
import { useExtendedMutation } from 'mutations';

const AccountStatsContext = createContext(null);

const AccountStatsProvider = ({ children }) => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [stats, setStats] = useState(null);

  const statsMutation = useExtendedMutation(
    getUserStats,
    (data) => setStats(data),
    (error) => console.error('Error fetching user stats:', error)
  );

  useEffect(() => {
    if (token) {
      statsMutation.mutateOnVirtualThread({ token });
    }
  }, [token]);

  const incrementWordCount = () =>
    setStats(prev => prev ? { ...prev, wordCount: prev.wordCount + 1 } : prev);

  const incrementCategoryCount = () =>
    setStats(prev => prev ? { ...prev, categoryCount: prev.categoryCount + 1 } : prev);

  return (
    <AccountStatsContext.Provider value={{ stats, incrementWordCount, incrementCategoryCount }}>
      {children}
    </AccountStatsContext.Provider>
  );
};

const useAccountStats = () => useContext(AccountStatsContext);

export { AccountStatsProvider, useAccountStats };
